export const TAG_COLORS = {
    GREEN: '#76b900',
    RED: '#eb340f',
    ORANGE: '#ffa01c',
    GREY: '#8c8c8c'
}